"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ContentBox: {
    position: 'relative'
  },
  Anchor: {
    width: 'fit-content'
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map